'use strict';

function EMTRequestIframe() {
  this.id = null;
  this.node = null;
  this.extends = [EMTController, _Paths];
  this._analytics = new Analytics();
  this._history = new History();

  this.classes = {
    interacIframeAnchor: '.js--iframe-anchor'
  };

  this.init = function () {
    var _this = this;

    this._super();

    $.when(this.emtRequestModelPromise).then(function () {
      _this._removeProgressLoader();
      _this.emtRequestUrl = _this.getEmtRequestIframe();
      _this.emtRequestId = _this.getEmtRequestId();

      // Page Guard
      if (!_this.emtRequestUrl) {
        _this.stopPollEmtStatus();
        return _this._history.goToUrl(_this.paths.emt[_this.emtRequestProduct].fund);
      }

      // _Try_ to open interact window pop up initally
      //  there's an anchor for users to click if this fails.
      _this._openInteracWindow();
      _this.pollEmtStatus(_this.emtRequestId, _this._routeToNextStep.bind(_this));
    });

    this.interacIframeAnchor = this.node.querySelector(this.classes.interacIframeAnchor);
    this.interacIframeAnchor.addEventListener('click', function () {
      _this._openInteracWindow();
    });
  };

  this.initAllReady = function () {};

  this._openInteracWindow = function () {
    var windowConfigs = 'height=700px width=700px scrollbars=auto, resizable=no, location=no, status=no';
    window.open(this.emtRequestUrl, 'Interac Request Window Popup', windowConfigs);
  };

  this._routeToNextStep = function () {
    var emtStatus = this.getEmtStatus();
    var url = '';
    switch (emtStatus) {
      case 'DECLINED':
      case 'EXPIRED':
      case 'FAILED':
        url = this.paths.emt[this.emtRequestProduct].status;
        break;
      case 'DEPOSIT_COMPLETE':
      case 'COMPLETED':
        url = this.paths.emt[this.emtRequestProduct].complete;
        break;
      case 'DEPOSIT_PENDING':
      case 'DEPOSIT_INITIATED':
      case 'PENDING':
        // Pending is Stub
        url = this.paths.emt[this.emtRequestProduct].processing;
        break;
      default:
    }
    if (url) {
      this.stopPollEmtStatus();
      this._history.goToUrl(url);
    }
  };

  this.destroy = function () {
    this.stopPollEmtStatus();
  };
}